import { useCallback } from 'react';
import { FieldValues, useForm } from 'react-hook-form';

/**
 * Wrapper around useForm that prevents submitting when the form is submitting
 */
export function useFlyForm<T extends FieldValues>(
  ...args: Parameters<typeof useForm<T>>
) {
  const form = useForm<T>(...args);

  const handleSubmit = useCallback(
    (onSubmit: (data: T) => unknown) => {
      if (form.formState.isSubmitting) {
        return (e: React.FormEvent<HTMLFormElement>) => e.preventDefault();
      }

      return form.handleSubmit((data) => onSubmit(data));
    },
    [form]
  );

  return {
    ...form,
    handleSubmit,
  };
}
